import { setCookie, getCookie } from "../../../utils/cookieUtils";
import { getEnvironmentProperties } from "../../common/environmentProperties";

const MC_REFRESH_TOKEN_KEY = calculateEnv() + "MC_SESSION";
const MC_ACCESS_TOKEN_KEY = calculateEnv() + "MC_AUTH";

export function setSessionCookies(accessToken, refreshToken) {
    const cookieDomain = calculateDomain();
    setCookie(MC_ACCESS_TOKEN_KEY, accessToken, 24, "/", cookieDomain);
    setCookie(MC_REFRESH_TOKEN_KEY, refreshToken, 24, "/", cookieDomain);
}

export function getSessionCookies() {
    return [getCookie(MC_ACCESS_TOKEN_KEY), getCookie(MC_REFRESH_TOKEN_KEY)];
}


export function removeSessionCookies() {
	const [accessToken, refreshToken] = getSessionCookies();
	const cookieDomain = calculateDomain();

	if (accessToken) {
    	setCookie(MC_ACCESS_TOKEN_KEY, accessToken, -1, "/", cookieDomain);
	}
	if (refreshToken)
    	setCookie(MC_REFRESH_TOKEN_KEY, refreshToken, -1, "/", cookieDomain);
}

function calculateDomain() {
	let cookieDomain = window.location.hostname.split(".");
    cookieDomain.shift();
    return cookieDomain.join(".");
}

function calculateEnv() {
	const subtitle = getEnvironmentProperties().subtitle;
	return subtitle !== undefined ? subtitle.toUpperCase() + '_' : "";
}


// WEBPACK FOOTER //
// ./src/components/common/sessions/tokenHelper.js